import React, { useEffect, useState } from "react";
import Layout from "../components/Layout/Layout";
import BannerHeroSection from "../components/HeroSection/BannerHeroSection";
import HeroSectionImage from "../assets/contactUsHero.png";
import SendMessage from "../components/Contact/SendMessage";
import Campus from "../components/Homepage/Campus";
import axios from "axios";
import { motion } from "framer-motion";

const Contact = () => {
  const [contactData, setContactData] = useState([]);

  useEffect(() => {
    const getContactData = () => {
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/contact`)
        .then((response) => {
          setContactData(response?.data[0]);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    };
    getContactData();
  }, []);

  return (
    <Layout>
      <BannerHeroSection
        title="Contact Us"
        subtitle="Get in touch with our team for any questions or support you need"
        bannerImage={HeroSectionImage}
        height="h-64 md:h-80 lg:h-96 xl:h-[500px]"
        className="-mx-4 md:-mx-12 lg:-mx-16 mb-6 md:mb-8 lg:mb-10"
      />

      {/* Contact Form Section */}
      {/* <div className="bg-gradient-to-br from-gray-50 to-blue-50 py-16 lg:py-20">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-center mb-12 lg:mb-16"
            >
              <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl leading-tight font-extrabold text-[#14183E] mb-6">
                Get In Touch
              </h1>
              <p className="text-lg lg:text-xl text-[#5E6282] max-w-3xl mx-auto">
                Have questions about our training programs? Need support with your course? 
                Our team is here to help you succeed.
              </p>
            </motion.div>
          </div>
        </div>
      </div> */}

      <SendMessage contact={contactData} />

      {/* Campuses Section */}
      <Campus showHeader={false} />
    </Layout>
  );
};

export default Contact;
